/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * Contact: redjar.redelivery@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface StoreNewStoreBody { 
    cdCity: number;
    cdStoreType: number;
    dsName: string;
    dsEmail: string;
    dsPhone: string;
    dsAddress: string;
    dsPostalCode?: string;
    dsImg?: string;
    image: Blob;
    dsPassword?: string;
    dtOpeningTime: Date;
    dtClosingTime: Date;
    dtOpeningTime2?: Date;
    dtClosingTime2?: Date;
    nmDeliveryTime: number;
    qtPersonCost: number;
    qtLatitude: number;
    qtLongitude: number;
    qtAppCommission?: number;
    dsSlogan: string;
    dsLogo?: string;
    logoImage: Blob;
    dsCode: string;
    additionalImages?: Array<Blob>;
    itemImagesUrl?: Array<string>;
    dsApiMeli: string;
    dsMeliPublicKey?: string;
    qtDeliveryValue?: number;
    nmMaximumKmDelivery?: number;
}